import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import  CustomerModel  from "models/CustomerModel";
import { getAuthorizedApi, processAxiosError } from "services/common.service";
import DropDownModel from "models/DropDownModel";

export const getOemDropDown = createAsyncThunk("customer/getOemDropDown", async (_, { dispatch }) => {
    try {
        const response = await getAuthorizedApi().get<DropDownModel[]>("/Customer/GetOemDropDown");
        return response.data;
    } catch (err) {
        const error = err as AxiosError;
        processAxiosError(error, dispatch);
    }
    return [];
});

export const getCustomerById = createAsyncThunk("customer/getCustomerById", async (customerId: string, { dispatch }) => {
    try {
        const response = await getAuthorizedApi().get<CustomerModel>("/Customer/GetCustomerById?id=" + customerId.toString());
        return response.data;
    } catch (err) {
        const error = err as AxiosError;
        processAxiosError(error, dispatch);
    }
    return {
        customerId: ""
    };
});